<div class="container">
  <h1 class="mt120 ml-3">Introduction to iTIM</h1>
</div>

<div class="mainContnet">
  <div class="container">
    <p>
      if you looking for discipling materials that will both “equip the saints
      for the work of ministry” AND result in “building up the body of Christ”
      (Ephesians 4:12)? iTIM’s 18-course curriculum may be just what you have
      been looking for. By design iTIM will not only equip your people for
      ministry, but will also involved your people <b><em>in</em></b> ministry.
    </p>
    <p>
      iTIM features a <b><em>“head”</em></b
      >, <b><em>“heart”</em></b
      >, and <b><em>“hands”</em></b> approach to learning. This means that all
      iTIM courses include:
    </p>
    <ul class="list">
      <li>vital content</li>
      <li>life applications</li>
      <li>ministry involvement</li>
    </ul>
    <p>
      To learn more about iTIM and how to use it effectively, and to purchase
      books, take the free iTIM Training Seminar.
    </p>
  </div>
</div>
